import React from "react"

export default React.createClass({
  componentDidMount() {
    let container = ReactDOM.findDOMNode(this);
    if (window.FB != null) {
      return FB.XFBML.parse(container);
    }
  },

  render() {
    return (
      <span className="react-facebook-widget">
        {this.props.children}
      </span>
    );
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/components/ReactFacebookWidget.jsx